import { Component, OnInit } from '@angular/core';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { ApiService } from '../../shared/api.service';
import { EventSendeurService } from '../../shared/event-sendeur.service';
import { EditLicenceKeyComponent } from './edit-licencekey/edit-licencekey.component';
import { LocalDataSource } from 'ng2-smart-table';
import { Router } from '@angular/router';
import { plainToClass } from 'class-transformer';
import swal from 'sweetalert2';
import { Formation } from '../../shared/data/formation';
import { LicenceKey } from '../../shared/data/licencekey';
import { User } from '../../shared/data/user';

@Component({
  selector: 'ngx-licencekey',
  templateUrl: './licencekey.component.html',
  styleUrls: ['./licencekey.component.scss']
})
export class LicenceKeyComponent implements OnInit {

  categories:any =[];
  
  source: LocalDataSource =  new LocalDataSource();
  settings = {
 
     hideSubHeader: false,
     mode: 'external',
     actions: {
      columnTitle: '',
      position: 'left',
      add: true,
      edit: false,
      delete: true,
     },
     add: {
      addButtonContent: '<i class="nb-plus"></i>',
      confirmCreate: false,
    },
     edit: {
       editButtonContent: '<i class="nb-edit"></i>',
       saveButtonContent: '<i class="nb-checkmark"></i>',
       cancelButtonContent: '<i class="nb-close"></i>',
       confirmSave:false
     },
     delete: {
       deleteButtonContent: '<i class="nb-trash"></i>',
       confirmDelete: true,
     },
   columns: {
    id: {
       title: 'ID',
       type: 'number',
       filter: false,
    },
    date_create: {
      title: 'Date creation',
      type: 'string',
    },
    num: {
       title: 'Numero',
       type: 'string',
       valuePrepareFunction: (num:string) => { return num.toUpperCase(); },
    },
    activated: {
      title: 'Etat',
      type: 'string',
    },
    date_activation: {
      title: 'Date activation',
      type: 'string',
    },
    nbr_activation: {
      title: 'Nombre d\'activation',
      type: 'string',
    },
    nbr_activated: {
      title: 'Nombre activés',
      type: 'string',
    },
    nbr_data_base: {
      title: 'Nombre dossier',
      type: 'string',
    },
    nbr_jour: {
      title: 'Nombre de jour',
      type: 'string',
    },
    user: {
      title: 'Compte utilisateur',
      type: 'string',
      // type: 'html',
      valuePrepareFunction: (user:User) => { return (user !== null)?user.nom:''; },
      // filter: false
    },
    appname: {
      title: 'Application',
      type: 'string',
   },
   useroffer: {
    title: 'Type de code',
    type: 'string',
    valuePrepareFunction: (useroffer) => { return (useroffer)?'Avec compte':'Sans compte'; },
  },
     /* labelCycle: {
      title: 'Cycle',
      type: 'string',
    }, */
    /* label_categorie: {
      title: 'Categorie',
      type: 'string',
    }, */
    /* labelAdmission: {
      title: 'Admission',
      type: 'string',
    }, */
   /*  is_publish: {
      title: '',
      type: 'custom',
      renderComponent: PublishRenderComponent, // ne pas oublier de déclarer dans le module et d'ajouter dans l'entré entryComponents
      filter: false,
    }, */
  
   },
   pager : {
                 perPage :10
   },
  
  };

 constructor(private router:Router,private dialogService: NbDialogService,private apiService:ApiService,private sendeurService:EventSendeurService,private toastr:NbToastrService) { }
 
 
  ngOnInit() {

    this.getLicence();

    /* this.sendeurService.formationEvent.subscribe(data =>{
      this.getLicence();
    }) */

  }

 

  getLicence(){

    this.apiService.getAllLicenceProvider().subscribe(data =>{
     

      this.source.load( plainToClass( LicenceKey, data) );
      /* const tmps = data as any[];   
      this.categories = tmps.map(tmp => {
        return {
        
          nom: tmp.nom,   
          id:tmp.id,
          description:tmp.description
        };
      
      }); */

    })

  }

  
  

  onDelete(event){
    // this.dialogService.open(DeleteCategoryComponent,{ context:{id:$event.data.id}});


  
    // this.dialogService.open(DeletePageComponent,{context:{id:$event.data.id}});
    const key = plainToClass( LicenceKey,  event.data as object);

    if(key.activated) {

      alert('licence déjà activé');
      return; 

    }

    swal({
      title: 'Suppression clé',
      text: 'Voulez - vous vraiment supprimer ' + key.num + ' ? Vous ne pourrez plus annuler cet opération',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Confirmer',
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      preConfirm: () => {

        // this.dialogIsNotShow = true;

        return this.apiService.deleteLicenceProvider(key.id).subscribe(data =>{

          // console.log(data);
          this.source.remove(event.data);
          this.toastr.success("Suppréssion réussie", key.num);

        },(err) =>{

          this.toastr.danger("Echec de suppréssion ");
          if(err.error.code ===401){
            localStorage.clear();
            window.location.reload();
            let link2 = ['/login'];
            this.router.navigate(link2);
          }

          if(err.error.code ===500){

            this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");

          }

        })

      },
    }).then((result) => {

      if (result.value) {


        /* this.toastr.success("Suppréssion réussie", formation.titre); */

      }

      // this.dialogIsNotShow = false;

    });


  }
  
  select($event){
    //this.dialogService.open(EditLicenceKeyComponent,{context:{id:$event.data.id}});
  }

  onCreate(event){
    this.createKey();
  }

  createKey(){
      this.dialogService.open(EditLicenceKeyComponent,{context:{id:0}}).onClose.subscribe(data => {

        /* if ( data !== undefined ) {

          if (typeEdit === 'update' ) {
            this.source.update(product, data);
            this.sharedMethods.sweetalert('success', ' Produit Modifié', '');
          }

          if (typeEdit === 'add' ) {
            this.source.prepend(data);
            this.sharedMethods.sweetalert('success', ' Produit créer avec succèss', '');
          }

        }

        this.dialogIsNotShow = true; */

        this.ngOnInit();


    });
  }

  

}
